import { useTranslate } from 'react-polyglot';
import { observer } from 'mobx-react';

import {
  BasicSubtitle,
  BiggerSubtitle,
  Breakpoint,
  Tooltip,
  useBreakpoint,
} from '@genially/design-system';

import { useHostClientContext } from '../../../HostClientProvider/hooks/useHostClientContext';
import { PlayersTitle, StyledWarningIcon, Wrapper } from './ParticipantsInfo.styled';

export const ParticipantsInfo = observer(() => {
  const t = useTranslate();

  const { client } = useHostClientContext();

  const { isDownwards } = useBreakpoint();

  const isMobile = isDownwards(Breakpoint.xs);

  const hasPlayers = client.players.length > 0;

  return (
    <Tooltip
      text={t('__new.play.creatorLobby.participantsNumber.tooltip')}
      disabled={hasPlayers}
      variant={Tooltip.Variant.LIGHT}
      placement={isMobile ? 'bottom' : 'top'}
    >
      <Wrapper>
        {!hasPlayers && <StyledWarningIcon />}

        <PlayersTitle
          with={BiggerSubtitle}
          on={{ [Breakpoint.md]: BasicSubtitle }}
          $showWarning={client.isPlayersLimitReached || !hasPlayers}
        >
          {t('__new.play.creatorLobby.participants', { number: client.players.length })}
        </PlayersTitle>

        {client.isPlayersLimitReached && <StyledWarningIcon />}
      </Wrapper>
    </Tooltip>
  );
});
